const Group = ({ className, children }) => (
  <div className={`group${className ? ` ${className}` : ''}`}>{children}</div>
)

export default Group
